//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Pagination from "../../../../components/Pagination";
import CardMini from "@/components/articles/CardMini";
import CardVeryMax from "@/components/articles/CardVeryMax.vue";
import Card from "@/components/articles/Card.vue";
import CardMax from "@/components/articles/CardMax.vue";
import Article from "@/components/articles/Article.vue";
import ArticleLoading from "@/components/articles/ArticleLoading.vue";
import SPage from "~/components/page/SPage.vue";
import {getOgTitle} from "~/helpers/metaHelper";

export default {
  name: "ArticlesPage",
  data: function () {
    return {
      isShowArtile: false,
    };
  },
  head: function () {
    return this.getHead();
  },
  async asyncData({$api, route, params, error}) {
    const category = route?.params?.category;
    let query = {...route.query};
    query.page = Boolean(params.pathMatch) ? params.pathMatch : query.page;

    const apiRoute = Boolean(category === "news") ? "news" : "articles";
    const apiSearch = Boolean(apiRoute === "articles") ? `?${Object.keys(query)
        .map((key) => {
          return `${key}=${query[key]}`;
        })
        .join("&")}&filter[category_slug]=${
        params.category
      }&expand=category,tags`
      : `?${Object.keys(query)
        .map((key) => {
          return `${key}=${query[key]}`;
        })
        .join("&")}`;

    const articlesResponse = await $api.agent.transport.get(`${apiRoute}${apiSearch}`).catch((err) => {
      return null
    });
    let articlesList = articlesResponse?.data ? articlesResponse.data : [];
    const {data: categoriesInit} = await $api.agent.transport.get("/articles/categories");
    let {data: article} = Boolean(params.article)
      ? await $api.agent.transport
        .get(`${apiRoute}/${params.article}?expand=category`)
        .catch(() => {
          return {data: {error: true}};
        })
      : null;
    if (article.error) {
      error({statusCode: 404});

      return null;
    }

    let breadcrumbs = [{path: "/", title: "Главная"}];

    if (apiRoute === "news") {
      articlesList = articlesList.map((article) => {
        return {
          ...article,
          category: {
            slug: "news",
          },
        };
      });

      article = {
        ...article,
        category: {
          slug: "news",
        },
      };
    }

    let categories = [
      {
        id: 0,
        name: "Всё",
        slug: "",
      },
      {
        id: 1,
        name: "Новости",
        slug: "news",
      },
    ];

    categoriesInit.map((category) => {
      categories.push({
        ...category,
        slug: `${category.slug}`,
      });
    });

    const pagination = {
      page: Number(articlesResponse?.headers?.["x-pagination-current-page"] || 1),
      perPage: Number(articlesResponse?.headers?.["x-pagination-per-page"] || 1),
      pageCount: Number(articlesResponse?.headers?.["x-pagination-page-count"] || 1),
      totalCount: Number(articlesResponse?.headers?.["x-pagination-total-count"] || 0),
    };

    return {
      article,
      articlesList,
      categories,
      pagination,
      activeCategory: params.category,
      breadcrumbs,
    };
  },
  components: {
    Pagination,
    CardMini,
    CardMax,
    Card,
    Article,
    SPage,
    CardVeryMax,
    ArticleLoading,
  },
  computed: {
    getDescription() {
      return this.getArticle.content || this.getArticle.description || '&nbsp;'
    },

    getImgPath() {
      return this.$img(String(this.article?.image_id || 0), {
        width: 1000,
        format: "jpg",
      });
    },
    articles: function () {
      return this.articlesList;
    },

    getArticle() {
      return this.article;
    },

    getArticlesContainer: function () {
      const articles = this.articlesList;

      // Логика для отрисовки нестандартной грид сетки, смотреть в components/original-stat-page/..
      // let containers = [];
      //
      // let indexContainer = 0;
      // let isMirrorView = false;
      // let container = [];
      // articles.map((article) => {
      //   let limitCount = Boolean(isMirrorView) ? 6 : 5;
      //
      //   if (indexContainer < limitCount) {
      //     let classes = [
      //       "col-span-3 row-start-1 col-start-1",
      //       "col-span-6 row-start-1 col-start-4",
      //       "col-span-3 row-start-1 col-start-10 row-span-2",
      //       "col-span-6 row-start-2 col-start-1",
      //       "col-span-3 row-start-2 col-start-7",
      //     ];
      //     let classesMirror = [
      //       "col-span-3 row-start-1 col-start-1 row-span-2",
      //       "col-span-6 row-start-1 col-start-4",
      //       "col-span-3 row-start-1 col-start-10",
      //       "col-span-3 row-start-2 col-start-4",
      //       "col-span-3 row-start-2 col-start-7",
      //       "col-span-3 row-start-2 col-start-10",
      //     ];
      //     let sizesCard = ["default", "big", "very-big", "big", "default"];
      //     let sizesCardMirror = [
      //       "very-big",
      //       "big",
      //       "default",
      //       "default",
      //       "default",
      //       "default",
      //     ];
      //     let classesArticles = Boolean(isMirrorView)
      //       ? classesMirror[indexContainer]
      //       : classes[indexContainer];
      //     let viewCardArticle = Boolean(isMirrorView)
      //       ? sizesCardMirror[indexContainer]
      //       : sizesCard[indexContainer];
      //
      //     container.push({
      //       ...article,
      //       classContainer: classesArticles,
      //       viewCardArticle: viewCardArticle,
      //     });
      //     indexContainer++;
      //   }
      //
      //   if (indexContainer >= limitCount) {
      //     containers.push(container);
      //     container = [];
      //     indexContainer = 0;
      //
      //     isMirrorView = !isMirrorView;
      //   }
      // });
      //
      // if (container.length > 0) {
      //   containers.push(container);
      // }

      return articles;
    },
  },
  created() {
    this.isShowArtile = true;
  },
  methods: {
    setCategory: function (id) {
      this.activeCategory = id;
    },

    getClassBg: function (idx) {
      if (idx > 3) {
        idx = idx - Math.floor(idx / 4) * 4;
      }

      // if ((idx + 1) % 6 === 0) return "col-span-3";
      // if ((idx + 1) % 5 === 0) return "col-span-3";
      if ((idx + 1) % 4 === 0) return "bg-[#F4EFF4]";
      if ((idx + 1) % 3 === 0) return "bg-[#F4F2EA]";
      if ((idx + 1) % 2 === 0) return "bg-[#F3EFF1]";
      if ((idx + 1) % 1 === 0) return "bg-[#F1F6F8]";
    },
    getClassGrid: function (idx) {
      if (idx > 5) {
        idx = idx - Math.floor(idx / 6) * 6;
      }

      if ((idx + 1) % 6 === 0) return "col-span-3";
      if ((idx + 1) % 5 === 0) return "col-span-3";
      if ((idx + 1) % 4 === 0) return "col-span-6";
      if ((idx + 1) % 3 === 0) return "col-span-3";
      if ((idx + 1) % 2 === 0) return "col-span-6";
      if ((idx + 1) % 1 === 0) return "col-span-3";
    },

    getUrlArticle: function () {
      return "#";
    },

    onChangePage: async function (page) {
      await this.$router.push({
        path: `/stat/${this.$route.params.category}/page${page}`,
      });
    },
    onChangePerPage: function (perPage) {
    },
    onLoadMore: async function (page, updateRoute = true) {
      let newPagination = {...this.pagination};
      newPagination.page = page;
      this.pagination = newPagination;

      if (updateRoute) {
        this.$router.replace({query: {page: page}});
      }

      let query = {...this.$route.query};
      query.page = page;

      const articlesResponse = await this.$api.agent.transport.get(
        `articles?${Object.keys(query)
          .map((key) => {
            return `${key}=${query[key]}`;
          })
          .join("&")}&filter[category_slug]=${
          this.$route.params.category
        }&expand=category,tags`
      );
      const articlesList = [...this.articlesList, ...articlesResponse.data];

      this.articlesList = articlesList;

      return articlesList;
    },

    getHead: function () {
      return {
        title: this?.article?.seo_title,
        meta: [
          {
            hid: "metadescription",
            name: "description",
            content: this?.article?.seo_description,
          },
          {name: "keywords", content: this?.article?.seo_keywords},

          {
            hid: "og:type",
            property: "og:type",
            content: "article",
          },
          {
            hid: "og:title",
            property: "og:title",
            content: getOgTitle(this?.article?.seo_title, this.$store.state.appState?.config),
          },
          {
            hid: "og:site_name",
            property: "og:site_name",
            content: "Linza",
          },
          {
            hid: "og:description",
            property: "og:description",
            content:
              this?.article?.announce ||
              this?.article?.title ||
              "og:description",
          },
          {
            hid: "og:image",
            property: "og:image",
            content: this.getImgPath,
          },
          {
            hid: "twitter:description",
            name: "twitter:description",
            content:
              this?.article?.announce ||
              this?.article?.title ||
              "og:description",
          },
          {
            hid: "twitter:image",
            name: "twitter:image",
            content: this.getImgPath,
          },
          {
            hid: "twitter:title",
            name: "twitter:title",
            content:
              this?.article?.announce ||
              this?.article?.title ||
              "og:description",
          },
          {
            hid: "twitter:card",
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
      };
    },

    nextArticle: async function (lastArticleId, updateRoute) {
      const articlesList = this.articlesList;
      const component = this.$refs["article-modal"];

      const lastArticleIndex = articlesList.findIndex(
        (t) => Number(t.id) === lastArticleId
      );
      let article = articlesList[lastArticleIndex + 1];

      if (!article) {
        if (this.pagination.page >= this.pagination.pageCount) {
          component.isLoadNextArticle = false;

          return null;
        }

        const articlesListLoad = await this.onLoadMore(
          this.pagination.page + 1,
          false
        );
        article = articlesListLoad[lastArticleIndex + 1];
      }

      const category = article?.category?.slug || article.category_slug;
      const apiRoute = Boolean(category === "news") ? "news" : "articles";
      const {data: articleResponse} = await this.$api.agent.transport.get(
        `${apiRoute}/${article.slug}?expand=category`
      );

      const nextArticle = {
        ...articleResponse,
        apiRoute,
      };
      component?.setNextArticle(nextArticle, updateRoute);
    },
  },
};
